import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { listInvoices, Invoice } from "../services/billing.service";

export const invoiceKeys = {
  all: ["invoices"] as const,
  list: () => [...invoiceKeys.all, "list"] as const,
};

/**
 * Hook to fetch the current tenant's Stripe invoices.
 */
export const useInvoices = (options?: { enabled?: boolean }) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery<Invoice[], Error>({
    queryKey: invoiceKeys.list(),
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently();
      const response = await listInvoices(accessToken);

      if (response.error) {
        throw new Error(response.error);
      }

      return response.data ?? [];
    },
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};
